export const containsIllegalCharacters = (filename: string) => {
    const illegalCharacters: string[] = ["'"];
    let rejectFilename = false;

    if (illegalCharacters.some((v) => filename.includes(v))) {
        rejectFilename = true;
    }

    return rejectFilename;
};
